var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8476_3693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "url(#paint0_radial_8476_3693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8594 55.0625H18.1406C17.2812 55.0625 16.5781 54.3594 16.5781 53.5C16.5781 52.6406 17.2812 51.9375 18.1406 51.9375H61.8594C62.7188 51.9375 63.4219 52.6406 63.4219 53.5C63.4219 54.3594 62.7188 55.0625 61.8594 55.0625Z",
    fill: "url(#paint1_linear_8476_3693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7656 34.1875C25.3199 34.1875 27.3906 32.1168 27.3906 29.5625C27.3906 27.0082 25.3199 24.9375 22.7656 24.9375C20.2113 24.9375 18.1406 27.0082 18.1406 29.5625C18.1406 32.1168 20.2113 34.1875 22.7656 34.1875Z",
    fill: "url(#paint2_radial_8476_3693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2344 34.1875C59.7887 34.1875 61.8594 32.1168 61.8594 29.5625C61.8594 27.0082 59.7887 24.9375 57.2344 24.9375C54.6801 24.9375 52.6094 27.0082 52.6094 29.5625C52.6094 32.1168 54.6801 34.1875 57.2344 34.1875Z",
    fill: "url(#paint3_radial_8476_3693)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8476_3693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 40) scale(42.6073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#FFE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFBF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#FF9C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#FFB53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8476_3693",
    x1: 40,
    y1: 50.1895,
    x2: 40,
    y2: 56.4972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8476_3693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7659 29.5645) scale(5.15813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#7A3F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#7E421C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#884D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9B5E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#B4762D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68632"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8476_3693",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2341 29.5645) scale(5.15812 5.15813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#7A3F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#7E421C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#884D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9B5E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#B4762D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68632"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8476_3693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion2);
export default __webpack_public_path__ + "static/media/emotion2.a8989c65ef80705c1e0738a99f5f3cd6.svg";
export { ForwardRef as ReactComponent };